const reducerPaths = {
  auth: "auth",
  alertDialog: "alertDialog",
  myGarage: "myGarage",
  sellMyCarDashboard: "sellMyCarDashboard",
  sidebar: "sidebar",
  buyNow: "buyNow",
  liveAuction: "liveAuction",
  carsInNegotiation: "carsInNegotiation",
  authApi: "authApi",
  signinApi: "signinApi",
  signupApi: "signupApi",
  myGarageApi: "myGarageApi",
  buyNowApi: "buyNowApi",
  liveAuctionApi: "liveAuctionApi",
  carEstimateSlice: "carEstimateSlice",
  carEstimateApi: "carEstimateApi",
  upcomingCarsApi: "upcomingCarsApi",
  watchListApi: "watchListApi",
  carDetailsApi: "carDetailsApi",
  carsInNegotiationApi: "carsInNegotiationApi",
  dashboardReportApi: "dashboardReportApi",
  vehicleApi: "vehicleApi",
  contactUsApi: "contactUsApi",
  geographyApi: "geographyApi",
  paypalApi: "paypalApi",
  carfaxApi: "carfaxApi",
  myOrdersApi: "myOrdersApi",
  dashboardPaginationFiltersApi: "dashboardPaginationFiltersApi",
  walletAndPaymentsApi: "walletAndPaymentsApi",
  paymentsApi: "paymentsApi",
};

export { reducerPaths };
